function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { H4 } from '@finect/tabular-core/Headings';
import { Button } from '@finect/tabular-core/Button';
import { getProductTypeLabel } from '@finect/front-resources/Products';
import { search, fullSearch } from './actions';
import { SearchBox } from './SearchBox';
import { Inner, Results, Title, Footer } from './partials';
import { ProductsContainer } from './ProductsContainer';
import { isValidSearch, shortcuts } from './utils';
import { Result, Shortcut } from './Result';
import { EmptyResults, EmptyResultsFetching, WithFundPlaceholder } from './EmptyResults';
export var ProductFinder = function (_React$Component) {
  _inherits(ProductFinder, _React$Component);
  var _super = _createSuper(ProductFinder);
  function ProductFinder() {
    var _this;
    _classCallCheck(this, ProductFinder);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      query: '',
      searching: false,
      results: [],
      selected: _this.props.initialSelection ? _this.props.initialSelection : [],
      chip: null,
      focused: _this.props.autofocus || false,
      fetching: false,
      bag: []
    });
    _defineProperty(_assertThisInitialized(_this), "searchTimeout", null);
    _defineProperty(_assertThisInitialized(_this), "throttleTimeout", null);
    _defineProperty(_assertThisInitialized(_this), "pendingQuery", null);
    _defineProperty(_assertThisInitialized(_this), "executeSearch", function (query) {
      var _this$props = _this.props,
        productType = _this$props.productType,
        showAllProductTypes = _this$props.showAllProductTypes,
        limit = _this$props.limit;
      var searchFn = showAllProductTypes ? fullSearch : search;
      var searchParams = showAllProductTypes ? [query, limit] : [productType, query, limit];
      searchFn.apply(void 0, searchParams).then(function (results) {
        if (_this.state.query !== query) return;
        _this.setState({
          results: results,
          fetching: false
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (query) {
      _this.setState({
        query: query
      });
      if (!isValidSearch(query)) return _this.setState({
        results: []
      });
      if (_this.state.chip) return;
      _this.setState({
        fetching: true
      });
      if (_this.searchTimeout) clearTimeout(_this.searchTimeout);
      _this.searchTimeout = setTimeout(function () {
        if (_this.throttleTimeout) {
          _this.pendingQuery = query;
          return;
        }
        _this.executeSearch(query);
        _this.throttleTimeout = setTimeout(function () {
          _this.throttleTimeout = null;
          if (_this.pendingQuery) {
            var nextQuery = _this.pendingQuery;
            _this.pendingQuery = null;
            _this.executeSearch(nextQuery);
          }
        }, 3000);
      }, 500);
    });
    _defineProperty(_assertThisInitialized(_this), "handleAlreadySelected", function (product) {
      if (typeof _this.props.onAlreadySelected === 'function') {
        _this.props.onAlreadySelected(product);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {});
    _defineProperty(_assertThisInitialized(_this), "handleResultClick", function (product) {
      _this.props.onChange && _this.props.onChange(product);
    });
    _defineProperty(_assertThisInitialized(_this), "handleShortcutClick", function (chip) {
      _this.setState({
        chip: chip
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleChipClose", function () {
      _this.setState({
        chip: null
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      _this.setState({
        focused: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSelectProduct", function (product) {
      var id = product.entity.id;
      var exists = _this.state.bag.filter(function (_ref) {
        var entity = _ref.entity;
        return entity.id === id;
      }).length > 0;
      if (!exists && _this.state.bag.length + 1 > _this.props.max) {
        return;
      }
      var newBag = !exists ? [].concat(_toConsumableArray(_this.state.bag), [_objectSpread({}, product)]) : _this.state.bag.filter(function (_ref2) {
        var entity = _ref2.entity;
        return entity.id !== id;
      });
      _this.setState({
        bag: _toConsumableArray(newBag)
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleAction", function () {
      _this.props.onAction && _this.props.onAction(_this.state.bag);
    });
    _defineProperty(_assertThisInitialized(_this), "addInitialProduct", function (fund) {
      var product = {
        entity: fund,
        subtype: 'fund'
      };
      var exists = _this.state.bag.filter(function (_ref3) {
        var entity = _ref3.entity;
        return entity.id === fund.id;
      }).length > 0;
      var newBag = !exists ? [].concat(_toConsumableArray(_this.state.bag), [_objectSpread({}, product)]) : _toConsumableArray(_this.state.bag);
      _this.setState({
        bag: _toConsumableArray(newBag)
      });
    });
    return _this;
  }
  _createClass(ProductFinder, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.props.initialProduct) {
        this.addInitialProduct(this.props.initialProduct);
      }
      if (this.props.initialShortcut) {
        var shortcut = shortcuts.find(function (item) {
          return item.id === _this2.props.initialShortcut;
        });
        if (shortcut) {
          this.setState({
            chip: shortcut
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      if (this.throttleTimeout) clearTimeout(this.throttleTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state = this.state,
        results = _this$state.results,
        query = _this$state.query,
        chip = _this$state.chip,
        focused = _this$state.focused,
        fetching = _this$state.fetching;
      var _this$props2 = this.props,
        title = _this$props2.title,
        placeholder = _this$props2.placeholder,
        productType = _this$props2.productType,
        filterByProductType = _this$props2.filterByProductType,
        user = _this$props2.user,
        multiple = _this$props2.multiple,
        onAction = _this$props2.onAction,
        compact = _this$props2.compact,
        showAllProductTypes = _this$props2.showAllProductTypes;
      var shortcutsToShow = shortcuts.filter(function (item) {
        if (_this3.props.shortcutsExclude && _this3.props.shortcutsExclude.includes(item.id)) return false;
        if (item.condition) return item.condition(_this3.props);
        return true;
      });
      return React.createElement(Inner, {
        isCompact: true
      }, title ? React.createElement(Title, null, React.createElement(H4, null, title)) : null, React.createElement(SearchBox, {
        compact: compact,
        placeholder: placeholder || "Busca un ".concat(showAllProductTypes ? 'producto' : getProductTypeLabel(productType, 'singular', 'lowercase'), " para poder comparar"),
        onChange: this.handleInputChange,
        chip: chip,
        onChipClose: this.handleChipClose,
        onFocus: this.handleFocus,
        autofocus: this.props.autofocus
      }), fetching ? React.createElement(EmptyResultsFetching, null) : null, !fetching && query && !chip ? React.createElement(Results, null, results.map(function (product, index) {
        var additionalProps = multiple ? {
          onSelect: function onSelect() {
            _this3.handleSelectProduct(product);
          },
          isChecked: Boolean(_this3.state.bag.find(function (item) {
            return item.entity.id === product.entity.id;
          }))
        } : {};
        return React.createElement(Result, _extends({
          compact: compact,
          key: index,
          result: product,
          onClick: function onClick() {
            _this3.handleResultClick(product);
          },
          withProductTypeChip: showAllProductTypes
        }, additionalProps));
      })) : null, productType && !fetching && (!chip && focused && !query || !chip && !focused && !query && compact) ? React.createElement(Results, null, shortcutsToShow.map(function (shortcut, index) {
        return React.createElement(Shortcut, {
          key: "shortcut-".concat(index),
          shortcut: shortcut,
          onClick: function onClick(item) {
            _this3.handleShortcutClick(item);
          }
        });
      })) : null, !chip && !focused && !query && !compact ? React.createElement(WithFundPlaceholder, null) : null, chip && productType ? React.createElement(ProductsContainer, {
        initialProduct: this.props.initialProduct,
        compact: this.props.compact,
        bag: this.state.bag,
        multiple: this.props.multiple,
        onSelect: function onSelect(product) {
          _this3.handleSelectProduct(product);
        },
        key: chip.id,
        user: user,
        productType: productType,
        filterByProductType: filterByProductType,
        type: chip.id,
        onChange: this.handleResultClick,
        query: query
      }) : null, query !== '' && !results.length && !chip && !fetching ? React.createElement(EmptyResults, null) : null, onAction ? React.createElement(Footer, null, React.createElement(Button, {
        disabled: !(this.state.bag.length > 1),
        onClick: this.handleAction
      }, "Comparar", this.state.bag.length > 1 ? " ".concat(this.state.bag.length, " ").concat(showAllProductTypes ? 'productos' : getProductTypeLabel(productType, 'shortPlural', 'lowercase')) : '')) : null);
    }
  }]);
  return ProductFinder;
}(React.Component);
_defineProperty(ProductFinder, "defaultProps", {
  shortcutsExclude: [],
  filterByProductType: true,
  multiple: false,
  compact: false,
  showAllProductTypes: false,
  max: 5
});